import { ErrorPage, PageLayout } from "@ezmid/components-library";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";

import { useGetBackOfficeGetLecturerQuery } from "../../../api/lecturer.generated";
import { ParamId } from "../../../enums/types";
import { makeRoute } from "../../../hooks/route";
import { AllRoutes } from "../../route/Route";
import { LecturerDetailPageContent } from "../organisms/LecturerDetailPageContent";

export function LecturerDetailPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id }: ParamId = useParams();
  const { isFetching, currentData, isError, isSuccess } =
    useGetBackOfficeGetLecturerQuery(
      {
        id: id ?? "",
      },
      {
        refetchOnMountOrArgChange: true,
      }
    );

  return isError ? (
    <ErrorPage
      errorMessageText={t("app.page.error.page.not.found")}
      messageForUser={t("app.page.error.defaultMessage")}
      hasGoBackButton
      buttonText={t("app.goToDasboard")}
      onButtonClick={() => navigate(makeRoute(AllRoutes.DASHBOARD))}
    />
  ) : (
    <PageLayout title={t("app.page.lecturers.heading")}>
      <LecturerDetailPageContent
        isError={isError}
        isFetching={isFetching}
        currentData={currentData}
        isSuccess={isSuccess}
      />
    </PageLayout>
  );
}
